import React from "react"
import { SearchOperation } from "../types"

export const SearchContext = React.createContext<SearchOperation>({
  results: undefined,
  filters: undefined,
  isLastResultsPage: false,
  loading: false,
  error: undefined,
  called: false,
  ready: false,
  operationId: undefined,
})

export const SearchProvider = SearchContext.Provider

export const useSearchResults = () => React.useContext(SearchContext)
